import {formattedPropertyModel, intlShape} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './DateFormatter.less';

class MonthYearFormatter extends React.PureComponent {
  render() {
    const {intl, value} = this.props;
    const propDefinition = new formattedPropertyModel.FormattedProperty({
      type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_MONTH_YEAR,
    });
    const formattedValue = value
      ? formattedPropertyModel.FormattedProperty.formatValue(
          propDefinition,
          value,
          intl
        )
      : '';
    return value ? (
      <div className={styles.dlDateFormatter} title={formattedValue}>
        {formattedValue}
      </div>
    ) : (
      ''
    );
  }
}

MonthYearFormatter.displayName = 'MonthYearFormatter';

MonthYearFormatter.propTypes = {
  value: PropTypes.string,
  intl: intlShape.isRequired,
};

MonthYearFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(MonthYearFormatter);
